module.exports = __webpack_public_path__ + "img/brandbg.74d2dd66.png";